import React from "react";
import { Resources } from "../../../data/Resources";
import MediaFeedContentPage from "../media-feed/MediaFeedContentPage";

export const BooksFeedPage = () => {
  return <MediaFeedContentPage resource={Resources.BOOKS} />;
};
